import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Paper, Container, Grid, Alert, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useDarkMode } from './App';

export default function Login({ onLogin }) {
  const { darkMode } = useDarkMode();
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario, password })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.success === true && data.token) {
          localStorage.setItem('token', data.token);
          // Obtener roles del usuario
          try {
            const rolesRes = await fetch('/api/roles', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${data.token}`
              },
              body: JSON.stringify({ usuario })
            });
            if (rolesRes.ok) {
              const rolesData = await rolesRes.json();
              // rolesData ahora es {roles: [...], perfil: {...}}
              const rolesDns = rolesData.roles || rolesData;
              const roles = (Array.isArray(rolesDns) ? rolesDns : []).map(dn => {
                const match = dn.match(/cn=([^,]+)/);
                return match ? match[1] : dn;
              });
              localStorage.setItem('roles', JSON.stringify(roles));
              if (rolesData.perfil) {
                localStorage.setItem('perfil_territorial', JSON.stringify(rolesData.perfil));
              } else {
                localStorage.removeItem('perfil_territorial');
              }
              if ([1, 2].includes(Number(rolesData.cargo_id_sin_perfil))) {
                localStorage.setItem('cargo_id_sin_perfil', String(rolesData.cargo_id_sin_perfil));
              } else {
                localStorage.removeItem('cargo_id_sin_perfil');
              }
              if (rolesData.nombre_completo) {
                localStorage.setItem('nombre_completo', rolesData.nombre_completo);
              }
            } else {
              localStorage.setItem('roles', JSON.stringify([]));
              localStorage.removeItem('perfil_territorial');
              localStorage.removeItem('cargo_id_sin_perfil');
            }
          } catch {
            localStorage.setItem('roles', JSON.stringify([]));
            localStorage.removeItem('perfil_territorial');
            localStorage.removeItem('cargo_id_sin_perfil');
          }
          onLogin(data.token);
        } else {
          setError('Usuario o contraseña incorrectos');
        }
      } else {
        setError('Usuario o contraseña incorrectos');
      }
    } catch {
      setError('Error de conexión');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="xs">
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor={darkMode ? '#121212' : '#f5f5f5'}>
        <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 600, mx: 'auto', px: { xs: 1, sm: 2 }, py: { xs: 2, sm: 3 } }}>
          <Typography variant="h5" mb={2} color="primary" textAlign="center">Iniciar sesión</Typography>
          <form onSubmit={handleSubmit}>
            <TextField label="Usuario" fullWidth margin="normal" value={usuario} onChange={e => setUsuario(e.target.value)} autoFocus />
            <TextField label="Contraseña" type={showPassword ? "text" : "password"} fullWidth margin="normal" value={password} onChange={e => setPassword(e.target.value)}
              InputProps={{ endAdornment: <InputAdornment position="end"><IconButton onClick={() => setShowPassword(!showPassword)} edge="end">{showPassword ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment> }} />
            {error && <Alert severity="error" sx={{ width: '100%', mt: 1 }}>{error}</Alert>}
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading} sx={{ mt: 2 }}>
              {loading ? 'Ingresando...' : 'Ingresar'}
            </Button>
          </form>
        </Paper>
      </Box>
    </Container>
  );
}
